module.exports = __webpack_public_path__ + "static/media/lac-logo.62db47d6.png";